import { Component, OnInit, HostListener, HostBinding } from '@angular/core';
import { TITLES } from '../../../assets/data';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-content-tabs',
  templateUrl: './content-tabs.component.html',
  styleUrls: ['./content-tabs.component.scss']
})
export class ContentTabsComponent implements OnInit {
  title = TITLES;
  isFixedNavbar;
  // public courses: any [] = Coso;
  public video:boolean;
  public path: string;
  public param:string;

  constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,location: Location, router: Router) {
    router.events.subscribe((val) => {
      this.path = location.path();
      this.path = this.path.substring(1);
    });
  }

  @HostBinding('class.navbar-opened') navbarOpened = false;

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.param = params['header'];
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (offset > 0) {
      this.isFixedNavbar = true;
    } else {
      this.isFixedNavbar = false;
    }
  }

  toggleNavbar() {
    this.navbarOpened = !this.navbarOpened;
  }

  openVideo(){
    this.video = true;
  }
  
  iFrameUrl: SafeResourceUrl;
  displayIFrame = false;
  onOpenIframe() : void{
    this.iFrameUrl = {};
    this.displayIFrame = true;
  }

  closeVideo() : void{
    this.video = false;
  }
}
